import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { NgxResizeObserverModule } from 'ngx-resize-observer';

import { SvgIconModule } from '../svg-icon/svg-icon.module';

import { ScrollbarComponent } from './scrollbar.component';
import { ScrollbarDirective } from './scrollbar.directive';

@NgModule({
  declarations: [ScrollbarComponent, ScrollbarDirective],
  imports: [CommonModule, SvgIconModule, DragDropModule, NgxResizeObserverModule],
  exports: [ScrollbarComponent, ScrollbarDirective]
})
export class ScrollbarModule {}

export * from './scrollbar.component';
export * from './scrollbar.directive';
